var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLink2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24.0006,
    r: 24,
    fill: "#004887"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5 30.0006C18.1022 30.0006 17.7206 30.1586 17.4393 30.44C17.158 30.7213 17 31.1028 17 31.5006C17 32.0529 16.5523 32.5006 16 32.5006C15.4477 32.5006 15 32.0529 15 31.5006C15 30.5724 15.3687 29.6821 16.0251 29.0257C16.6815 28.3694 17.5717 28.0006 18.5 28.0006H32C32.5523 28.0006 33 28.4483 33 29.0006C33 29.5529 32.5523 30.0006 32 30.0006H18.5Z",
    fill: "#FCFCFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5 15.0006C18.1022 15.0006 17.7206 15.1586 17.4393 15.44C17.158 15.7213 17 16.1028 17 16.5006V31.5006C17 31.8984 17.158 32.28 17.4393 32.5613C17.7206 32.8426 18.1022 33.0006 18.5 33.0006H31V15.0006H18.5ZM18.5 13.0006H32C32.5523 13.0006 33 13.4483 33 14.0006V34.0006C33 34.5529 32.5523 35.0006 32 35.0006H18.5C17.5717 35.0006 16.6815 34.6319 16.0251 33.9755C15.3687 33.3191 15 32.4289 15 31.5006V16.5006C15 15.5724 15.3687 14.6821 16.0251 14.0257C16.6815 13.3694 17.5717 13.0006 18.5 13.0006Z",
    fill: "#FCFCFC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLink2);
export default __webpack_public_path__ + "static/media/icon-link2.485c9cd78c3649815248871e9ef681e4.svg";
export { ForwardRef as ReactComponent };